import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../utils/token";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditScholarPackage({
  rowData,
  serviceId,
  setSelectedRowData,
}) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");

  const [serviceList, setServiceList] = useState([]);
  const [serviceName, setServiceName] = useState(null);
  const [subServiceList, setSubSurviceList] = useState([]);
  const [subserviceName, setSubserviceName] = useState([]);
  const [subServiceId, setSubServiceId] = useState([]);

  const [testTypeList, setTestTypeList] = useState([]);
  const [testTypeName, setTestTypeName] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState([]);
   const [countryList, setCountryList] =useState([])
      const [countryName, setCountryName] =useState(null)
      const [currency,setcurrency] =useState(rowData?.currency)
  const [subServicePrograms, setSubServicePrograms] = useState(null);

  const [programList, setProgramList] = useState(null);
  const [selectedClassList, setSelectedClassList] = useState([
    { id: 1, name: "Class 9", value: "class_9" },
    { id: 2, name: "Class 10", value: "class_10" },
    { id: 3, name: "Class 11", value: "class_11" },
    { id: 4, name: "Class 12", value: "class_12" },
  ]);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState(null);
  const [partnerUnivercity, setPartnerUniverCity] = useState(
    rowData?.partner_university || null
  );
  const [nonpartnerUnivercity, setNonPartnerUniverCity] = useState(
    rowData?.non_partner_university
  );
  const [changes, setChanges] = useState({});
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState(null);
   const [installmentsCount, setInstallmentsCount] = useState(rowData?.payable_installment || 0);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    defaultValues: {
      currency: rowData?.currency,
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const fileeredServis = data.filter(
            (i) => i.service_name !== "Undefined"
          );
          const selectedService = data.find(
            (i) => i.id === rowData?.service_id?.id
          );
          setServiceList(fileeredServis);
          setServiceName(selectedService);
          setValue("service_id", selectedService?.id || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handlechangeService = (e, value) => {
    setSubserviceName([]);
    setSubServiceId([]);

    setSubServicePrograms(null);
    setClassName(null);
    setServiceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);
    setTestTypeName(null);
    setValue("service_id", value?.id);
    handleFieldChange("service_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const filteredServices = data.filter(
            (i) => i.service_id === serviceName?.id
          );
          const selectedSubservice = filteredServices.filter((i) =>
            rowData?.sub_service_id.includes(i.name)
          );
          const selectedSubserviceIds = selectedSubservice.map((i) => i.id);
          setSubSurviceList(filteredServices);
          setSubserviceName(selectedSubservice);
          setSubServiceId(selectedSubserviceIds);

          setValue("sub_service_id", selectedSubserviceIds || []);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [serviceName]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice-program`);
        if (response.ok) {
          const data = await response.json();
          const filterddata = data.filter((i) =>
            subServiceId.includes(i.sub_service_id)
          );

          console.log("filterddata", filterddata);
          const selectedProgram = filterddata.find(
            (i) => i.id === rowData?.scholars_program_id?.id
          );

          setProgramList(filterddata);
          setSubServicePrograms(selectedProgram || null);
          setValue("scholars_program_id", selectedProgram?.id || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [subserviceName]);

  const handlechangeprogram = (e, value) => {
    setClassName(null);
    setSubServicePrograms(value);
    setValue("scholars_program_id", value?.id);
    setValue("scholars_class", null);
    handleFieldChange("scholars_program_id", value?.id);
    handleFieldChange("scholars_class", null);
  };


  const allSubServiceList = [{ name: "Select All" }, ...subServiceList];

  const handlechangeSubservice = (e, value) => {
    setSubServicePrograms(null);
    setClassName(null);

    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);

    const subserviceIds = value.map((i) => i.id);
    setSubserviceName(value);
    setSubServiceId(subserviceIds);
    setValue("sub_service_id", subserviceIds);
    handleFieldChange("sub_service_id", subserviceIds);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}advisordashboard/gettesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypeList(data);
        const selectedTestType = data.find(
          (i) => i.id === rowData?.test_type?.id
        );
        setTestTypeName(selectedTestType);
        setValue("test_type", selectedTestType?.id || null);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  const handleTestTypeChange = (e, value) => {
    setTestTypeName(value);
    setValue("test_type", value.id);
    handleFieldChange("test_type", value.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();
          const filterdSubTestType = data.find(
            (i) => i.id === rowData?.sub_test_type_id?.id
          );

          setSubtestTypeList(data);
          setsubtestType(filterdSubTestType);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
        // Fetch menu items using the fetch function
        fetch(`${API_ENDPOINT}country`)
          .then((response) => response.json())
          .then((data) => {
            const filteredcountry=data.filter((i)=>i.country_name==="India" || i.country_name==="Nepal" )
            setCountryList(filteredcountry);
  
               const selectedCountry=filteredcountry.find((i)=>i.country_name===rowData?.country_id?.country_name)
           setCountryName(selectedCountry)
           setValue("country_id",selectedCountry?.id)
         
          })
        
          .catch((error) => {
            console.error("Error fetching testtypes:", error);
          });
      }, []);
  
  const handleCountryChange = (e, value) => {
    setBranchName([]);
    setValue("branch_id", []);
    setCountryName(value);

    setValue("country_id", value?.id);
    setcurrency(value?.currency_code);
    setValue("currency", value?.currency_code);
    handleFieldChange("country_id", value?.id);
    handleFieldChange("currency", value?.currency_code);
    handleFieldChange("branch_id", []);
  };

   useEffect(() => {
     // Fetch menu items using the fetch function
     fetch(`${API_ENDPOINT}branch`)
       .then((response) => response.json())
       .then((data) => {
       
          const flteredBranch=data.filter((i)=>i.country_id===countryName?.id)
         const selectedBranch = flteredBranch.filter((i) =>
           rowData?.branch_id.includes(i.branch_name)
         );
 
           setBranchList(flteredBranch);
         setBranchName(selectedBranch);
         setValue("branch_id", selectedBranch.map((i) => i.id) || null);
       })
       .catch((error) => {
         console.error("Error fetching testtypes:", error);
       });
   }, [countryName]);

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];
  const handlebranchChange = (e, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      const selectedBranch = branchList.map((i) => i.id);
      setBranchName(branchList);
      setValue("branch_id", selectedBranch);
      handleFieldChange("branch_id", selectedBranch);
    } else {
      setBranchName(value);
      setValue(
        "branch_id",
        value.map((i) => i.id)
      );
      handleFieldChange(
        "branch_id",
        value.map((i) => i.id)
      );
    }
  };

  useEffect(() => {
    if (subServicePrograms?.name === "Accelerated SUAP (for 11-12 class)") {
      const filteredClass = selectedClassList.filter(
        (i) => !["class_9", "class_10"].includes(i.value)
      );
      const selectedClass = filteredClass.find(
        (i) => i.value === rowData?.scholars_class
      );
      setClassList(filteredClass);
      setClassName(selectedClass);
    } else {
      setClassList(selectedClassList);
      const selectedClass = selectedClassList.find(
        (i) => i.value === rowData?.scholars_class
      );
      setClassName(selectedClass);
    }
  }, [subServicePrograms]);

  const handleChangeClass = (e, value) => {
    setClassName(value);
    setValue("scholars_class", value?.value);
    handleFieldChange("scholars_class", value?.value);
  };

 

  const onSubmit = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };


    try {
      const requestData = {
        ...changes,
        user_id: parseInt(userId),
        package_id: rowData?.id,
      };

      if (changes?.payable_installment) {
      Object.assign(requestData, {
        service_id: 2,
        original_price: changes?.original_price ?? rowData?.original_price,
        installment_1_amount: changes?.installment_1_amount ?? null,
        installment_1_description: changes?.installment_1_description ?? null,
        installment_2_amount: changes?.installment_2_amount ?? null,
        installment_2_description: changes?.installment_2_description ?? null,
        installment_3_amount: changes?.installment_3_amount ?? null,
        installment_3_description: changes?.installment_3_description ?? null,
        installment_4_amount: changes?.installment_4_amount ?? null,
        installment_4_description: changes?.installment_4_description ?? null,
      });
    }

      const response = await fetch(
        `${API_ENDPOINT}package/update/updatepackage`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        showSnackbar(result.message, "success");

       setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar("Unknown user!", "error");
      } else if (response.status === 403) {
        showSnackbar("Unauthorized User!", "error");
      }else if (response.status === 409) {
        showSnackbar("Duplicate Package Name", "error");
      }
       else {
        showSnackbar(result.error, "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };


  //   Handle change field

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));

    setSelectedRowData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));

    setValue(fieldName, value); // Update form value
  };

   const handleInstallmentsChange = (value) => {
      setValue("payable_installment", value); 
      handleFieldChange("payable_installment", value);
      setInstallmentsCount(value === 1 ? 0 : value);

      // Clear/reset ALL installments always
      for (let i = 1; i <= 4; i++) {
        setValue(`installment_${i}_amount`, null); 
        handleFieldChange(`installment_${i}_amount`, null);       // reset to null
        setValue(`installment_${i}_description`, null);
        handleFieldChange(`installment_${i}_description`, null);  // reset to null
      }
};




  return (
    <>
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.service_id)}>
            <Typography variant="h6">
              Service{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="service_id"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  disableClearable
                  size="small"
                  value={serviceName}
                  onChange={handlechangeService}
                  options={serviceList}
                  getOptionLabel={(option) => option.service_name}
                  tooltipContent={(option) => option.service_name}
                  error={Boolean(errors.service_id)}
                  helperText={errors.service_id && errors?.service_id?.message}
                  readOnly
                />
              )}
            />
          </FormControl>
        </Grid>
        {serviceName !== null && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.sub_service_id)}>
              <Typography variant="h6">
                Sub Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="sub_service_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    multiple
                    value={subserviceName}
                    onChange={handlechangeSubservice}
                    options={subServiceList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    error={Boolean(errors.sub_service_id)}
                    helperText={
                      errors.sub_service_id && errors?.sub_service_id?.message
                    }
                    readOnly
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}

        {subserviceName?.name !== null && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h6">Admission Program</Typography>
              <Controller
                name="scholars_program_id"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={subServicePrograms}
                    onChange={handlechangeprogram}
                    options={programList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}

        {[
          "Advanced SUAP (for 8th class onwards)",
          "Accelerated SUAP (for 11-12 class)",
        ].includes(subServicePrograms?.name) && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h6">Class </Typography>
              <Controller
                name="scholars_class"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                defaultValue={rowData?.class_id}
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={className}
                    onChange={handleChangeClass}
                    options={classList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h6">
              Number of Partner Universities{" "}
            </Typography>
            <Controller
              name="partner_university"
              control={control}
              // rules={{ required: true }} // Add your validation rules here

              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  type="number"
                  value={partnerUnivercity}
                  onChange={(e) => {
                    setPartnerUniverCity(e.target.value);
                    setValue("partner_university", parseInt(e.target.value));
                    handleFieldChange(
                      "partner_university",
                      parseInt(e.target.value)
                    );
                  }}
                  size="normal"
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h6">
              Number Of Non Partner Universities{" "}
            </Typography>
            <Controller
              name="non_partner_university"
              control={control}
              // rules={{ required: true }} // Add your validation rules here
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  type="number"
                  value={nonpartnerUnivercity}
                  onChange={(e) => {
                    setNonPartnerUniverCity(e.target.value);
                    setValue(
                      "non_partner_university",
                      parseInt(e.target.value)
                    );
                    handleFieldChange(
                      "non_partner_university",
                      parseInt(e.target.value)
                    );
                  }}
                  size="normal"
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.package_name)}>
            <Typography variant="h6">
              Package Name{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="package_name"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              defaultValue={rowData?.package_name}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  onChange={(event) =>
                    handleFieldChange("package_name", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.package_name)}
                  helperText={
                    errors.package_name && errors?.package_name?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>

  <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(errors.country_id)}>
                      <Typography variant="h6">Country </Typography>
                      <Controller
                        name="country_id"
                        control={control}
                        rules={{ required: "This is required field" }} // Add your validation rules here
                        render={({ field }) => (
                          <CustomAutocompleteComp
                            {...field}
                            fullWidth
                            size="small"
                         disableClearable
                            value={countryName}
                            onChange={handleCountryChange}
                            options={countryList}
                            getOptionLabel={(option) => option.country_name}
                            tooltipContent={(option) => option.country_name}
                             error={Boolean(errors.country_id)}
                            helperText={
                              errors.country_id && errors?.country_id?.message
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

        {countryName && (
  <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.branch_id)}>
              <Typography variant="h6">currency</Typography>
              <Controller
                name="currency"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    multiple
                    value={currency}
                    InputProps={{readOnly:true , style:{borderRadius:'10px'}}}
               error={Boolean(errors.currency)}
                    helperText={
                      errors.currency && errors?.currency?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
)}

{countryName && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.branch_id)}>
              <Typography variant="h6">Branch</Typography>
              <Controller
                name="branch_id"
                control={control}
               rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    multiple
                    value={branchName}
                    onChange={handlebranchChange}
                    options={allBranchList}
                    getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                      error={Boolean(errors.branch_id)}
                      helperText={
                        errors.branch_id && errors?.branch_id?.message
                      }
                  />
                )}
              />
            </FormControl>
          </Grid>
           )}

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.original_price)}>
            <Typography variant="h6">
              Original Price{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="original_price"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              defaultValue={rowData?.original_price}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  type="number"
                  onChange={(event) => {
                    const value = event.target.value
                      ? parseInt(event.target.value)
                      : null;

                    handleFieldChange("original_price", value);

                    setValue("payable_installment", null);

                    handleInstallmentsChange(1);
                  }}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.original_price)}
                  helperText={
                    errors.original_price && errors?.original_price?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h6">Discounted Price </Typography>
            <Controller
              name="discounted_price"
              control={control}
              // rules={{ required: true }} // Add your validation rules here
              defaultValue={rowData?.discounted_price}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  type="number"
                  onChange={(event) =>
                    handleFieldChange(
                      "discounted_price",
                      parseInt(event.target.value)
                    )
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.payable_installment)}>
            <Typography variant="h6">Payable Installments </Typography>
            <Controller
              name="payable_installment"
              control={control}
              rules={{ required: "This is a required field"  }} // Add your validation rules here
              defaultValue={rowData?.payable_installment || 1}
              render={({ field }) => (
                <Select
                  {...field}
                  size="normal"
                  style={{ borderRadius: "10px" }}
                  onChange={(event) => {
                    const value = parseInt(event.target.value, 10);
                    handleInstallmentsChange(value);
                  }}
                >
                  <MenuItem value={1}>No installments</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </Grid>

        {/* Dynamic Installment Fields */}
        {Array.from({ length: installmentsCount }, (_, index) => (
          <Grid item container spacing={2} key={index}>
            {/* Installment Amount */}
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                error={Boolean(errors[`installment_${index + 1}_amount`])}
              >
                <Typography variant="h6">
                  {`Installment ${index + 1} Amount`}
                  <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
                </Typography>
                <Controller
                  name={`installment_${index + 1}_amount`}
                  control={control}
                  defaultValue={rowData?.[`installment_${index + 1}_amount`] || ""} // ✅ FIXED
                  rules={{ required: "This is a required field" }}
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      onChange={(event) =>
                        handleFieldChange(
                          `installment_${index + 1}_amount`,
                          parseInt(event.target.value) || null
                        )
                      }
                      type="number"
                      fullWidth
                      size="normal"
                      InputProps={{
                        style: {
                          borderRadius: "10px",
                        },
                      }}
                      error={Boolean(errors[`installment_${index + 1}_amount`])}
                      helperText={
                        errors[`installment_${index + 1}_amount`]?.message
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>

            {/* Installment Description */}
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                error={Boolean(errors[`installment_${index + 1}_description`])}
              >
                <Typography variant="h6">
                  {`Installment ${index + 1} Description`}
                  <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
                </Typography>
                <Controller
                  name={`installment_${index + 1}_description`}
                  control={control}
                  defaultValue={rowData?.[`installment_${index + 1}_description`] || ""} // ✅ FIXED
                  rules={{ required: "This is a required field" }}
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      onChange={(event) =>
                        handleFieldChange(
                          `installment_${index + 1}_description`,
                         event.target.value || null
                        )
                      }
                      fullWidth
                      size="normal"
                      InputProps={{
                        style: {
                          borderRadius: "10px",
                        },
                      }}
                      error={Boolean(errors[`installment_${index + 1}_description`])}
                      helperText={
                        errors[`installment_${index + 1}_description`]?.message
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        ))}


         <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth error={Boolean(errors.description)}>
                          <Typography variant="h6">
                            Description{" "}
                          </Typography>
                          <Controller
                            name="description"
                            control={control}
                            defaultValue={rowData?.description}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                onChange={(event) =>
                                  handleFieldChange("description", event.target.value)
                                }
                                multiline
                                rows={6}
                                size="normal"
                                InputProps={{
                                  style: {
                                    borderRadius: "10px",
                                  },
                                }}
                                error={Boolean(errors.description)}
                                helperText={errors.description && errors?.description?.message}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

        <Grid item xs={12} textAlign="end">
          <Button
            variant="contained"
            size="medium"
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
